export const searchFormOption = function () {
    return [
        {
            prop: 'username',
            label: '客户名称',
            type: 'input',
            placeholder: '客户名称'
        },
        {
            prop: 'tel',
            label: '客户电话',
            type: 'input',
            placeholder: '客户电话'
        },
		{
		    prop: 'vin',
		    label: '车架号',
		    type: 'input',
		    placeholder: '车架号'
		},
    ]
}

export default {}